var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7711_936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 4.2C28.1562 3.97757 27.763 3.843 27.3549 3.80812C26.9469 3.77325 26.5366 3.83914 26.16 4L13.82 8.86C13.5278 8.9789 13.2154 9.04003 12.9 9.04H5C4.33696 9.04 3.70107 9.30339 3.23223 9.77224C2.76339 10.2411 2.5 10.877 2.5 11.54V11.74H0V17.74H2.5V18C2.51567 18.6526 2.78596 19.2732 3.25311 19.7291C3.72027 20.1851 4.34722 20.4402 5 20.44L8 26.8C8.20314 27.2283 8.52296 27.5906 8.92272 27.8453C9.32249 28.1 9.78599 28.2368 10.26 28.24H11.52C12.1796 28.2347 12.8103 27.969 13.2749 27.5007C13.7394 27.0325 14 26.3996 14 25.74V20.68L26.16 25.54C26.4591 25.659 26.7781 25.7201 27.1 25.72C27.5994 25.7119 28.0858 25.5591 28.5 25.28C28.829 25.0579 29.1003 24.7607 29.2916 24.4129C29.4829 24.0651 29.5886 23.6768 29.6 23.28V6.26C29.5982 5.85304 29.497 5.45267 29.3053 5.09367C29.1136 4.73467 28.8372 4.4279 28.5 4.2ZM11.5 11.54V18H5V11.54H11.5ZM11.5 25.74H10.24L7.78 20.44H11.5V25.74ZM14.74 18.3C14.5025 18.1786 14.2549 18.0783 14 18V11.4C14.2525 11.3479 14.5001 11.2743 14.74 11.18L27.1 6.26V23.22L14.74 18.3ZM29.66 12.24V17.24C30.323 17.24 30.9589 16.9766 31.4278 16.5078C31.8966 16.0389 32.16 15.403 32.16 14.74C32.16 14.077 31.8966 13.4411 31.4278 12.9722C30.9589 12.5034 30.323 12.24 29.66 12.24Z",
    fill: "#28A745"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7711_936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.5a7d6bbc9b6b4b2619bf3c1c6997c004.svg";
export { ForwardRef as ReactComponent };